import React, { ReactNode } from 'react';
import { Card } from '../ui';
import { Logo } from '../shell/Logo';

export interface AuthLayoutProps {
  title: string;
  description?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

/**
 * Shared standalone frame for the seven auth pages (Login, Register, ForgotPassword,
 * ResetPassword, MagicLinkPage, EmailVerification, ImpersonatePage). These pages render
 * outside AppShell, so they bring their own full-height page background and centred column.
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({ title, description, children, footer }) => (
  <div className="flex min-h-screen flex-col items-center bg-page px-4 py-10 sm:py-14">
    <div className="w-full max-w-[26rem]">
      <div className="mb-6 flex justify-center">
        <Logo />
      </div>
      <Card padding="lg" className="border-0 bg-transparent shadow-none sm:border sm:border-line sm:bg-card sm:shadow-card">
        <div className="mb-6 text-center">
          <h1 className="font-display text-2xl font-semibold text-ink">{title}</h1>
          {description && <p className="mt-1 text-muted">{description}</p>}
        </div>
        {children}
      </Card>
      {footer && <div className="mt-6 text-center text-sm text-muted">{footer}</div>}
    </div>
  </div>
);
